/* eslint-disable import/no-cycle */
import store from '@/store';
/* eslint-enable import/no-cycle */

export default class Storage {
    static TOKEN_KEY = 'token';

    static setToken(token) {
        localStorage.setItem(Storage.TOKEN_KEY, JSON.stringify(token));
        if (store) {
            if (new Date(token.lifetime * 1000) > new Date()) {
                store.dispatch('login');
            } else {
                store.commit('logout');
            }
        }
    }

    static getToken() {
        const token = JSON.parse(localStorage.getItem(Storage.TOKEN_KEY)) || {
            authorization: '',
            lifetime: 0,
        };
        if (store) {
            if (new Date(token.lifetime * 1000) > new Date()) {
                store.dispatch('login');
            } else {
                store.commit('logout');
            }
        }
        return token;
    }

    static clearToken() {
        if (store) {
            store.commit('logout');
        }
        localStorage.removeItem(Storage.TOKEN_KEY);
    }
}
